import apiHandler from '../core/apiHandler';

const emailApi = apiHandler('email');

export default emailApi;
